import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fmtMoney } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Navbar } from "../components/Navbar";
import { CalendarCheck, CheckCircle, Clock } from "@phosphor-icons/react";

export default function Bookings() {
  const { user } = useAuth();
  const [bookings, setBookings] = useState([]);
  useEffect(() => { api.get("/bookings/mine").then(({ data }) => setBookings(data)); }, []);

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-10">
        <span className="overline text-xs text-orange-800">Réservations & Locations</span>
        <h1 className="font-display text-3xl font-bold text-stone-900 mt-1 mb-6">Mes réservations</h1>
        {bookings.length === 0 ? (
          <div className="bg-white border border-dashed border-stone-300 rounded-2xl py-16 text-center text-stone-400" data-testid="bookings-empty">
            <CalendarCheck size={40} className="mx-auto mb-3 opacity-40" />
            Aucune réservation pour le moment. <Link to="/catalog" className="text-orange-800 font-semibold">Explorer les biens</Link>
          </div>
        ) : (
          <div className="space-y-3">
            {bookings.map((b) => (
              <div key={b.id} data-testid={`booking-${b.id}`} className="bg-white border border-stone-200 rounded-2xl p-5 flex items-center justify-between flex-wrap gap-3">
                <div>
                  <div className="text-xs text-stone-500">{b.booking_type === "event" ? "Location courte durée" : b.booking_type === "caution" ? "Caution (achat)" : "Location longue durée"} · {b.owner_id === user.user_id ? "Reçue" : "Effectuée"}</div>
                  <h3 className="font-display text-lg font-bold text-stone-900">{b.property_title}</h3>
                  <div className="text-sm text-stone-500">{b.start_date}{b.end_date ? ` → ${b.end_date}` : ""}</div>
                </div>
                <div className="text-right">
                  <div className="font-display text-xl font-bold text-orange-800">{fmtMoney(b.amount)}</div>
                  <span className={`inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full mt-1 ${b.payment_status === "paid" ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>
                    {b.payment_status === "paid" ? <><CheckCircle weight="fill" size={13} /> Payé</> : <><Clock size={13} /> En attente</>}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
